import { useEffect, useState } from 'react'

/**
 * Die eine Grenze zwischen schmal und breit — **900 Punkte**.
 *
 * Dieselbe Zahl steht in `app.css` an `.shell`, und das ist kein Zufall,
 * sondern die Bedingung: eine zweite Umbruchbreite wäre eine zweite Wahrheit
 * darüber, was ein großer Bildschirm ist. Wer sie ändert, ändert beide.
 */
const BREIT = '(min-width: 900px)'

/**
 * Ob das Fenster breit genug für zwei Spalten ist — **und es geht mit**.
 *
 * `matchMedia` einmal abgefragt liefert einen Wert von damals: dreht jemand
 * das iPad, stimmt er nicht mehr. Deshalb wird zugehört und nicht gemessen.
 *
 * **Gebraucht wird das nur dort, wo eine Regel daran hängt** — nicht fürs
 * Aussehen. Was sich nur anders anordnet, macht das CSS; hierher gehört, was
 * der Browser nicht entscheiden kann. Hier ist es die Frage, ob ohne Angabe
 * schon eine Kategorie gewählt ist: auf dem breiten Fenster stünde die rechte
 * Spalte sonst leer da, auf dem schmalen gehört genau dorthin die Liste.
 */
export function useBreitesFenster(): boolean {
  const [breit, setBreit] = useState(
    () => typeof window !== 'undefined' && (window.matchMedia?.(BREIT).matches ?? false),
  )

  useEffect(() => {
    const frage = window.matchMedia?.(BREIT)
    if (frage === undefined) return

    const merke = () => setBreit(frage.matches)
    merke()
    frage.addEventListener('change', merke)
    return () => frage.removeEventListener('change', merke)
  }, [])

  return breit
}
